var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable complexity */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, { forwardRef } from 'react';
import cx from 'classnames';
import * as S from './styles';
var VARIANTS = {
    heading: {
        small: 'h4',
        medium: 'h3',
        large: 'h2',
        xlarge: 'h1'
    },
    body: {
        small: 'p',
        medium: 'p',
        large: 'p',
        xlarge: 'p',
        inherit: 'p'
    }
};
export var Typography = forwardRef(function Typography(_a, ref) {
    var as = _a.as, align = _a.align, children = _a.children, className = _a.className, font = _a.font, style = _a.style, color = _a.color, inline = _a.inline, lineThrough = _a.lineThrough, size = _a.size, underline = _a.underline, variant = _a.variant, weight = _a.weight, link = _a.link, rest = __rest(_a, ["as", "align", "children", "className", "font", "style", "color", "inline", "lineThrough", "size", "underline", "variant", "weight", "link"]);
    var resolvedVariant = VARIANTS[variant][size];
    var resolvedType = as !== 'p' && resolvedVariant ? as : resolvedVariant;
    var variantClassName = variant + "-" + size;
    var colorClassName = color + "-color";
    var weightClassName = weight + "-weight";
    var alignClassName = align + "-align";
    var underlineClassName = underline ? underline + "-underline" : false;
    var lineThroughClassName = lineThrough ? 'line-through' : false;
    var inlineClassName = inline ? 'inline' : false;
    var linkClassName = link ? 'link-appearance' : false;
    var secondaryFontFamilyClassName = font === 'secondary' ? 'font-family-secondary' : false;
    var rootClass = cx(className, variantClassName, colorClassName, weightClassName, alignClassName, underlineClassName, lineThroughClassName, inlineClassName, secondaryFontFamilyClassName, linkClassName);
    return (React.createElement(S.Typography, __assign({ as: resolvedType, ref: ref, className: rootClass, style: style }, rest), children));
});
Typography.defaultProps = {
    as: 'p',
    align: 'inherit',
    color: 'primary',
    inline: false,
    size: 'inherit',
    variant: 'body',
    weight: 'regular',
    font: 'primary',
    link: false
};
Typography.displayName = 'Typography';
export default Typography;
//# sourceMappingURL=Typography.js.map